module.exports = __webpack_public_path__ + "img/naver_step3.1a5f5d9a.png";